import type { IconRegistry } from './IconRegistry';

const RESOURCE_ICON_SOURCES: Record<string, string> = {
    wood: '/images/icon/wood.png',
    planks: '/images/icon/planks.png',
    stone: '/images/icon/stone.png',
    bricks: '/images/icon/bricks.png',
    charcoal: '/images/icon/charcoal.png',
    ironOre: '/images/icon/iron_ore.png',
    ironIngots: '/images/icon/iron_ingots.png',
    fiber: '/images/icon/fiber.png',
    clothRope: '/images/icon/cloth_rope.png',
    leather: '/images/icon/leather.png',
    food: '/images/icon/food.png',
    fish: '/images/icon/fish.png',
    tools: '/images/icon/tools.png',
    weapons: '/images/icon/weapon.png',
    goldOre: '/images/icon/gold_ore.png',
    coins: '/images/icon/coins.png',
};

export function registerResourceIcons(icons: IconRegistry): void {
    Object.entries(RESOURCE_ICON_SOURCES).forEach(([key, src]) => {
        icons.register(key, src);
    });
}

export function getResourceIconId(key: string): string | null {
    return RESOURCE_ICON_SOURCES[key] ? key : null;
}
